import * as THREE from 'three';
import { API_BASE } from './api-base.js';

// Shared album-cover texture loading, extracted from kaleido-drift.js once a
// second visualizer needed the same thing. Its users (droste-dive, halftone,
// kaleido-drift) treat the artwork as a SHADER TEXTURE rather than displaying
// it, and all have to get the same handful of details right - the proxy URL,
// the colour space, and above all the wrap mode, which differs per use and is
// the one setting that visibly breaks the image when it is wrong.

export function artProxyUrl(artUrl) {
  // Une pochette déjà embarquée (data-URL : c'est ainsi que l'extension
  // rapporte celles des enceintes Sonos) n'a rien à demander au relais.
  if (/^data:/i.test(artUrl)) return artUrl;
  return API_BASE + '/api/art-proxy?url=' + encodeURIComponent(artUrl);
}

// options:
//   wrap     THREE.RepeatWrapping (tiled patterns) or ClampToEdgeWrapping
//            (framed images, where a wrap would fold the far edge back in)
//   mipmaps  false for a texture only ever sampled near 1:1
export function loadArtworkTexture(url, options, onLoad, onError) {
  const opts = options || {};
  const wrap = opts.wrap || THREE.RepeatWrapping;
  new THREE.TextureLoader().load(
    artProxyUrl(url),
    (texture) => {
      texture.wrapS = wrap;
      texture.wrapT = wrap;
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.generateMipmaps = opts.mipmaps !== false;
      texture.minFilter = texture.generateMipmaps
        ? THREE.LinearMipmapLinearFilter
        : THREE.LinearFilter;
      texture.magFilter = THREE.LinearFilter;
      texture.anisotropy = 1;
      texture.needsUpdate = true;
      onLoad(texture);
    },
    undefined,
    () => { if (onError) onError(); }
  );
}

// UV scale that makes a texture COVER the frame with its aspect preserved -
// the shorter axis is cropped, never squashed. Applied about the centre:
//   uv = (vUv - 0.5) * scale + 0.5
export function coverScale(frameAspect, textureAspect) {
  const ratio = frameAspect / textureAspect;
  return ratio > 1
    ? new THREE.Vector2(1, 1 / ratio)  // frame wider than the image: crop height
    : new THREE.Vector2(ratio, 1);     // frame taller: crop width
}
